import { useLocalStorage } from "./localStorage";
const { getLocalStorageData } = useLocalStorage();

const postcodeApp = {
	validate: async (postcode, signal) => {
		const url =
			getLocalStorageData("postcodeApi") +
			"/postcodes/" +
			postcode +
			"/validate";
		const response = await fetch(url, { signal });
		const returnData = await response.json();
		return new Promise((resolve, reject) => {
			if (!response.ok) {
				const message = response.status;
				reject(message);
			} else {
				if (returnData.result) {
					resolve(true);
				} else {
					resolve(false);
				}
			}
		});
	},
	getData: async (postcode, signal) => {
		const url =
			getLocalStorageData("postcodeApi") + "/postcodes/" + postcode;

		const response = await fetch(url, { signal });
		const returnData = await response.json();

		return new Promise((resolve, reject) => {
			if (!response.ok) {
				const message = response.status;
				reject(message);
			} else {
				if (returnData.status == 200) {
					resolve(returnData.result);
				} else {
					resolve(false);
				}
			}
		});
	},
	validateGeo: async (lat, lon, postcode, signal) => {
		const url =
			getLocalStorageData("postcodeApi") +
			"/postcodes/?lat=" +
			lat +
			"&lon=" +
			lon;

		const response = await fetch(url, { signal });
		const returnData = await response.json();

		return new Promise((resolve, reject) => {
			if (!response.ok) {
				const message = response.status;
				reject(message);
			} else {
				if (returnData.status == 200) {
					let proceeded = 0;
					returnData.result.foreach((item) => {
						if (
							item.postcode.replace(/\s+/g, "").toUpperCase() ==
							postcode
						) {
							resolve(true);
						}
					});
					proceeded++;
					if (proceeded == returnData.result.length) {
						resolve(false);
					}
				} else {
					resolve(false);
				}
			}
		});
	},
};
export default postcodeApp;
